import React, { useContext } from 'react';
import './Login.css'
import firebase from "firebase/app"
import "firebase/auth"
import firebaseConfig from './firebaseConfig';
import { UserContext } from '../../../App';
import { useHistory, useLocation } from 'react-router-dom';

firebase.initializeApp(firebaseConfig)

const Login = () => {
  const history = useHistory();
  const location = useLocation();
  let { from } = location.state || { from: { pathname: "/" } };
  const [loggedInUser, setLoggedInUser] = useContext(UserContext)
    const handleGoogleSignIn = () => {
        const GoogleProvider = new firebase.auth.GoogleAuthProvider();
      
        firebase.auth()
        .signInWithPopup(GoogleProvider)
        .then((result) => {
          const user = result.user;
          setLoggedInUser(user)
          history.replace(from);
        
        }).catch((error) => {
          const errorMessage = error.message;
          console.log(errorMessage)
        });
      }
    return (
        <div className="text-center">
            <img src={require('../../../images/logo.png').default} className="img-fluid" style={{marginTop: '100px', marginBottom: '100px'}} alt="" />
            <h4><b>Login With</b></h4>
            <div
              className="d-flex justify-content-between align-items-center mt-3 d-block ms-auto me-auto mt-5"
              style={{ border: "1px solid #C7C7C7", borderRadius: "25px", width: '400px' }} onClick={handleGoogleSignIn}>
              <img
                src={require("../../../images/GIcon.png").default}
                alt=""
                style={{ marginLeft: "10px" }}
              />
              <p
                style={{
                  textAlign: "center",
                  marginRight: "120px",
                  marginTop: "10px",
                  cursor: 'pointer'
                }}
              >
                Continue with Google
              </p>
            </div>
        </div>
    );
};

export default Login;